import { useModal } from "../../../customHooks/useModal";
import Button from "../../Atoms/Button/Button";
import { useLocation } from "wouter";
import { Table } from "antd";
import HeaderTitle from "../../Molecules/HeaderTitle/HeaderTitle";
import ModalImportMasive from "../../Organisms/ModalImportMasive/ModalImportMasive";
import fetchProfiles from './profileJSON.json'

const columns = [
  {
    title: "Nombre y apellido",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Rol",
    dataIndex: "role",
    key: "role",
  },
  {
    title: "Campaña",
    dataIndex: "campain",
    key: "campain",
  },
  {
    title: "Acciones",
    dataIndex: "actions",
    key: "actions",
    fixed: 'right',
    // width: 150,
  },
];

const ManageRoles = () => {
  const [isOpenModal, openModal, closeModal] = useModal(false)
  const [, setLocation] = useLocation();
  const usersList = []

  const clickButtonTable = () => {
    setLocation('/perfiles-roles/editar')
  }

  // Fake Fetching
  fetchProfiles.profiles.forEach(user => 
    usersList.push({
      key: user.id,
      name:  user.name,
      email:  user.email,
      role: user.role,
      campain:  user.campain,
      actions: <Button small content="Editar" customClass="button s-large m-auto" type="primary" clickHandler={() => clickButtonTable()}/>
    },)
  )

  const handleModalCreationMasiva = () => {
    openModal()
  }

  return (
    <>
    <div className="nd-grid main-roles">
      <HeaderTitle
        headerText="Gestionar roles"
        downText="Administra los perfiles y roles de su cuenta."
        withDivider
      />
      <p className="mb-40 source-20"></p>
      <div className="nd-grid box s-pxy-20 m-pxy-50 ">
        <p className="source-24">Lista de perfiles</p>
        <div className="mt-20 table-container">
          <Table
            columns={columns}
            dataSource={usersList}
            pagination={false}
          />
        </div>
        <div className="buttons-container between mt-20">
          <Button content="Creación masiva" type="primary" customClass="s-large m-auto" clickHandler={() => handleModalCreationMasiva()}/>
          <Button content="Mostrar más registros" type="primary" customClass="s-large m-auto"  />
       </div>
      </div>
    </div>

     {/* Modal para la Creación masiva */}
     <ModalImportMasive 
        isOpenModal={isOpenModal} 
        closeModal={closeModal}
        columnsTableUserList={columns} 
        usersListToImport={usersList}
      />
    </>
  );
};

export default ManageRoles;
